import { FunctionComponent, useEffect } from 'react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import languages from '../../Data/languages';
import type { Template } from '../../types';

interface ResponseLimitReachedPageProps {
  template: Template;
}

export const ResponseLimitReachedPage: FunctionComponent<ResponseLimitReachedPageProps> = ({
  template
}) => {
  const appInsights = useAppInsightsContext();
  useEffect(() => {
    appInsights.trackPageView({ name: 'ResponseLimitReachedPage.tsx' });
  }, [appInsights]);
  const language = template.language.name;
  return (
    <div className="body">
      <h2>{languages.ACCEPTING_RESPONSES[language]}</h2>
      <p>{languages.RESPONSE_NOT_SAVED[language]}</p>
    </div>
  );
};
